/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  rectSortingStrategy,
} from '@dnd-kit/sortable';
import { PicSortable } from './pic.Sortable';
import { update } from '../../services/item';
import { canEditItemForItem, getId } from '../../utils/item';
import { PicNew } from './pic.New';
import { isTouchOnlyContext } from '../../utils/inputCapabilities';
import { isEditable } from '../../utils/roles';
import { Masonry } from '@mui/lab';

export const PicAll = props => {
  const { itemId, hideFirsts, zoom, masonry } = props;

  const item = useSelector(state => state.items[itemId]);
  const items = useSelector(state => state.items);
  const isModalOpen = useSelector(state => state.global.openModales);
  const isTouch = useSelector(state => state.global.isTouch);
  const [pics, setPics] = useState(item?.pics);
  const [disable, setDisable] = useState(false);
  const canEdit = canEditItemForItem(item, items);
  const touchLocked = isTouchOnlyContext(isTouch);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    })
  );

  const handleDragEnd = event => {
    const { active, over } = event;
    if (active.id !== over.id) {
      setPics(prev => {
        const oldIndex = prev.findIndex(
          item => Object.keys(item)[0] === active.id
        );
        const newIndex = prev.findIndex(
          item => Object.keys(item)[0] === over.id
        );
        return arrayMove(prev, oldIndex, newIndex);
      });
    }
  };

  useEffect(() => {
    if (item?.pics) {
      setPics(item.pics);
    }
  }, [item?.pics]);

  useEffect(() => {
    if (
      pics?.length === item?.pics?.length &&
      JSON.stringify(pics) !== JSON.stringify(item?.pics)
    ) {
      update(`items/${itemId}`, 'pics', pics);
    }
  }, [pics]);

  useEffect(() => {
    let isDisable = false;
    if (pics) {
      for (const pic of pics) {
        for (const id of Object.keys(isModalOpen)) {
          if (getId(pic) === id) {
            if (isModalOpen[id] === true) {
              isDisable = true;
              setDisable(true);
            }
          }
        }
      }
    }

    if (!isDisable) {
      setDisable(false);
    }
  }, [isModalOpen]);

  return (
    <div className='w-full flex flex-wrap flex-1'>
      {canEdit && <PicNew itemId={itemId} />}
      {((hideFirsts && pics?.length > 2) || !hideFirsts) && (
        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
        >
          <SortableContext
            items={pics?.map(tabObj => getId(tabObj))}
            strategy={rectSortingStrategy}
            disabled={isEditable(disable) || !canEdit || touchLocked}
          >
            {masonry ? (
              <Masonry>
                {pics?.map(tabObj => (
                  <PicSortable
                    key={getId(tabObj)}
                    id={getId(tabObj)}
                    picId={getId(tabObj)}
                    itemId={itemId}
                    zoom={zoom}
                    masonry={masonry}
                  />
                ))}
              </Masonry>
            ) : (
              pics?.map(tabObj => (
                <PicSortable
                  key={getId(tabObj)}
                  id={getId(tabObj)}
                  picId={getId(tabObj)}
                  itemId={itemId}
                  zoom={zoom}
                />
              ))
            )}
          </SortableContext>
        </DndContext>
      )}
    </div>
  );
};
